import * as React from 'react'

import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import List from '@mui/material/List'
import ListItemIcon from '@mui/material/ListItemIcon'
import Button from '@mui/material/Button'
import { styled } from '@mui/material/styles'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import IconButton from '@mui/material/IconButton'
import Typography from '@mui/material/Typography'
import Link from '@mui/material/Link'
import Divider from '@mui/material/Divider'

import Plus from 'mdi-material-ui/Plus'
import Close from 'mdi-material-ui/Close'

import FileDocumentOutline from 'mdi-material-ui/FileDocumentOutline'
import CurrentReport from './report-children/CurrentRepoet'
import ListItem, { ListItemProps } from '@mui/material/ListItem'
import { Card, CardContent, ListItemText } from '@mui/material'
import Icon from '@/@core/components/icon'
import { useTranslation } from 'react-i18next'
import CreateReportWizard from './report-children/new-report'
import {
  deleteReports,
  getReports,
  Reports
} from '@/@core/services/app.service'
import { useMutation, useQuery } from 'react-query'
import TanStackTable from '@/@core/components/tanstack-tables'
import { useRouter } from 'next/router'
import { Delete } from 'mdi-material-ui'
import AlertDialog from '@/@core/components/alert-dialog'

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2)
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1)
  }
}))

// ** Styled Components
const ListItemStyled = styled(ListItem)<
  ListItemProps & { component?: React.ElementType }
>(({ theme }) => ({
  borderLeftWidth: '3px',
  borderLeftStyle: 'solid',
  padding: theme.spacing(0, 5),
  marginBottom: theme.spacing(1)
}))

const Report = React.forwardRef(
  (
    props: {
      analysisInfo: any
      getReportsVariants: any
    },
    ref
  ) => {
    const { t } = useTranslation()
    const router = useRouter()

    const { id } = router.query

    const types = router.asPath.includes('/samples') ? 'sample' : 'analysis'
    const [type, setType] = React.useState('new')
    const [current, setCurrent] = React.useState<null | number | undefined>(
      null
    )
    const alertRef = React.useRef<any>()
    const [open, setOpen] = React.useState(false)
    const [openNewReport, setOpenNewReport] = React.useState(false)
    const [hisReportList] = React.useState([
      {
        name: '123',
        date: '2023-08-25 12:02:17',
        type: 'create'
      }
    ])

    const { data: reports, refetch } = useQuery({
      queryKey: ['reports'],
      queryFn: () =>
        getReports({
          pageNum: 1,
          pageSize: 1000,
          objectId: id as any,
          objectType: types
        }),
      keepPreviousData: true
    })

    const deleteReportsMutation = useMutation(deleteReports, {
      onSuccess: () => {
        refetch()

        changeType('new')

        // setOpenNewReport(true)

        setCurrent(null)
      }
    })

    const handleClickOpen = () => {
      setOpen(true)
    }

    const handleClose = () => {
      setOpen(false)

      setOpenNewReport(false)
    }
    const changeType = (value: string) => setType(value)

    const affected_child_patientName = React.useMemo(() => {
      const samples = props.analysisInfo.samples
      if (samples.length === 1) {
        return samples[0]?.patient?.patientName
      } else if (samples.length === 2) {
        return samples
          .map((sample: any) => sample?.patient?.patientName)
          .join(';')
      } else {
        return samples.find(
          (item: any) => item.sample?.type === 'affected_child'
        )?.patient.patientName
      }
    }, [props.analysisInfo.samples])
    React.useImperativeHandle(ref, () => {
      return {}
    })

    if (!reports || !reports.list) return null

    return (
      <Box>
        <Grid container>
          <Grid item xs={12} sm={2} sx={{ minHeight: '350px' }}>
            <Box sx={{ display: 'flex' }}>
              <Button
                variant="contained"
                startIcon={<Plus />}
                size="small"
                sx={{ marginLeft: 2, marginBottom: 3 }}
                onClick={() => {
                  changeType('new')

                  // setOpenNewReport(true)

                  setCurrent(null)
                }}
              >
                {t('Create Report')}
              </Button>

              {/* <Button
                variant="contained"
                startIcon={<Plus />}
                size="small"
                sx={{ marginLeft: 2, marginBottom: 3 }}
                onClick={() => {
                  //   changeType('history')
                  handleClickOpen()
                }}
              >
                {t('Historical report')}
              </Button> */}
            </Box>

            <Typography sx={{ fontSize: 22 }}>{t('My report')}</Typography>

            <Box paddingRight={5}>
              <List
                sx={{
                  width: '100%',
                  maxWidth: 260
                }}
              >
                {reports.list.map((items: Reports) => {
                  return (
                    <ListItemStyled
                      key={items.name}
                      sx={{
                        borderLeftColor:
                          current === items.id ? 'primary.main' : 'transparent',
                        cursor: 'pointer'
                      }}
                    >
                      <ListItemIcon
                        sx={{
                          color:
                            current === items.id ? 'primary.main' : 'inherit'
                        }}
                      >
                        <Icon icon={'mdi:file-document-outline'} />
                      </ListItemIcon>

                      <ListItemText
                        onClick={() => {
                          changeType('history')

                          setCurrent(items.id)
                        }}
                        sx={{ width: '80%' }}
                        primaryTypographyProps={{
                          noWrap: true,
                          sx: {
                            fontWeight: 500,
                            ...(current === items.id && {
                              color: 'primary.main'
                            })
                          }
                        }}
                      >
                        {items.name}
                      </ListItemText>

                      <IconButton
                        sx={{
                          color: current === items.id && ('primary.main' as any)
                        }}
                        onClick={() => {
                          alertRef.current.handleClickOpen(items.id)

                          // deleteReportsMutation.mutateAsync(items.id as number)
                        }}
                      >
                        <Delete />
                      </IconButton>
                    </ListItemStyled>
                  )
                })}
              </List>
            </Box>
          </Grid>

          <Grid item xs={12} sm={10}>
            <Card sx={{ width: '100%' }}>
              <CardContent sx={{ height: '100%' }}>
                {type === 'new' ? (
                  <React.Fragment>
                    <CreateReportWizard
                      fn={(id: number) => {
                        handleClose()

                        refetch()

                        changeType('history')

                        setCurrent(id)
                      }}
                      patientName={affected_child_patientName}
                      sampleName={props.analysisInfo.name}
                      getReportsVariants={props.getReportsVariants}
                    />
                  </React.Fragment>
                ) : type === '' ? (
                  ''
                ) : (
                  <CurrentReport
                    analysisInfo={props.analysisInfo}
                    current={current as number}
                    name={reports.list.find(
                      (item: { id: number | null | undefined }) =>
                        item.id === current
                    )}
                  />
                )}
              </CardContent>
            </Card>
          </Grid>
        </Grid>

        <BootstrapDialog
          maxWidth="xl"
          onClose={handleClose}
          aria-labelledby="customized-dialog-title"
          open={open}
        >
          <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
            {t('Historical report')}
          </DialogTitle>

          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500]
            }}
          >
            <Close />
          </IconButton>

          <DialogContent dividers>
            <Box sx={{ minWidth: 800 }}>
              <Grid container padding={2}>
                <Grid item xs={4}>
                  <Box>
                    <List
                      sx={{
                        width: '100%',
                        maxWidth: 360,
                        bgcolor: 'background.paper',
                        display: 'flex',
                        alignContent: 'center',
                        flexDirection: 'column'
                      }}
                    >
                      {hisReportList.map((items) => {
                        return (
                          <React.Fragment key={items.name}>
                            <Box>
                              <Typography
                                onClick={() => {
                                  // changeType('history')
                                }}
                                noWrap={true}
                              >
                                {items.date}
                              </Typography>
                            </Box>

                            <Box
                              sx={{
                                display: 'flex',
                                alignContent: 'center'
                              }}
                            >
                              {items.type === 'create' ? (
                                <ListItemIcon>
                                  <FileDocumentOutline />
                                </ListItemIcon>
                              ) : (
                                ''
                              )}

                              <Box
                                sx={{
                                  display: 'flex',
                                  alignContent: 'center',
                                  flexDirection: 'column'
                                }}
                              >
                                <Link
                                  onClick={() => {
                                    // changeType('history')
                                  }}
                                  noWrap={true}
                                >
                                  Vicky Liu
                                  {items.type === 'create'
                                    ? ' ' + t('Create Report')
                                    : ''}
                                </Link>

                                <Link
                                  onClick={() => {
                                    // changeType('history')
                                  }}
                                  noWrap={true}
                                >
                                  {t('report')}：{items.name}
                                </Link>
                              </Box>
                            </Box>
                          </React.Fragment>
                        )
                      })}
                    </List>
                  </Box>
                </Grid>

                <Grid item xs={8}>
                  <Divider orientation="vertical" flexItem />
                </Grid>
              </Grid>
            </Box>
          </DialogContent>

          {/* <DialogActions>
          <Button autoFocus onClick={handleClose}>
            Save changes
          </Button>
        </DialogActions> */}
        </BootstrapDialog>

        <BootstrapDialog
          maxWidth="xl"
          onClose={handleClose}
          aria-labelledby="customized-dialog-title"
          open={openNewReport}
        >
          <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
            {t('Create Report')}
          </DialogTitle>

          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500]
            }}
          >
            <Close />
          </IconButton>

          <DialogContent dividers>
            <Box sx={{ maxWidth: 900 }}>
              <CreateReportWizard
                fn={() => {
                  handleClose()

                  refetch()
                }}
                patientName={affected_child_patientName}
                sampleName={props.analysisInfo.name}
                getReportsVariants={props.getReportsVariants}
              />
            </Box>
          </DialogContent>
        </BootstrapDialog>

        <AlertDialog
          title={t('confirm')}
          description={t(
            'Are you sure you want to delete this item? This operation permanently deletes the item and cannot be restored. Make sure you have made your decision.'
          )}
          confirmFn={async (id: any) => {
            //

            if (id) await deleteReportsMutation.mutateAsync(id)
          }}
          ref={alertRef}
        />
      </Box>
    )
  }
)
export default Report
